import { MedicalAssistantWorkPeriodsDisplay } from '@/components/medical-assistant-work-periods/medical-assistant-work-periods-display';
import { OfficeMedicalAssistantsSection } from '@/components/medical-assistant-work-periods/office-medical-assistants-section';
import type { OfficeAssistantPeriod } from '@/hooks/use-office-assistant-periods-for-slot';

/** One Skello-imported work period, as carried on the slot list item. */
type LegacyWorkPeriod = {
  startTime: Date;
  endTime: Date;
  date: Date;
};

/**
 * "Heures assistante médicale" section, shared by the agenda and work-schedule
 * sheets. The planning grid is the source of truth: when it has periods for the
 * slot, the legacy Skello-imported hours are hidden so the two sources are
 * never shown side by side.
 *
 * @param props.assistantPeriods - server-computed periods from the planning grid
 * @param props.legacyWorkPeriods - Skello-imported hours, used as a fallback.
 *   Omitted on the substitute sheet, which shows only the periods its view
 *   model already vetted — the fallback would bypass that gate.
 * @returns the section element, or `null` when there are no hours to show
 */
export const SlotAssistantHoursSection = ({
  assistantPeriods,
  legacyWorkPeriods,
}: {
  assistantPeriods: OfficeAssistantPeriod[];
  legacyWorkPeriods?: LegacyWorkPeriod[];
}) => {
  const hasPlanningPeriods = assistantPeriods.length > 0;
  const hasLegacyPeriods = (legacyWorkPeriods?.length ?? 0) > 0;

  if (!hasPlanningPeriods && !hasLegacyPeriods) {
    return null;
  }

  return (
    <section className="border-b px-6 py-5">
      {hasPlanningPeriods ? (
        <OfficeMedicalAssistantsSection periods={assistantPeriods} />
      ) : (
        <MedicalAssistantWorkPeriodsDisplay
          workPeriods={legacyWorkPeriods ?? []}
        />
      )}
    </section>
  );
};
